import type { Route } from '@confluence/route/entry-points/Route.ts';

import * as route from './routes.ts';

/**
 * DO NOT USE THIS. Use route export directly
 * eg import { HOME } from '@confluence/named-routes/entry-points/routes'
 */
export const namedRoutes: { [name: string]: Route } = [
	route.BASE,
	route.WIKI,
	route.HOME,
	route.TEMPLATE_GALLERY,
	route.CALENDAR,
	route.MY_CALENDAR,
	route.QUESTIONS,
	route.QUESTIONS_NATIVE,
	route.SPACE_QUESTIONS_ASK_NATIVE,
	route.QUESTIONS_TOPICS_NATIVE,
	route.QUESTIONS_TOPIC_NATIVE,
	route.QUESTIONS_EXPERTS_NATIVE,
	route.QUESTION_NATIVE,
	route.CONTENT_HISTORY,
	route.CONTENT_HISTORY_LEGACY,
	route.EDIT_PAGE,
	route.EDIT_BLOG,
	route.EDIT_PAGE_V2,
	route.EDIT_BLOG_V2,
	route.EDIT_PAGE_EMBED,
	route.EDIT_PAGE_SMART_CREATE,
	route.CREATE_CONTENT,
	route.CREATE_PAGE,
	route.CREATE_BLOG,
	route.DELETE_PAGE,
	route.ONBOARDING,
	route.SPACE_DIRECTORY,
	route.SPACE_SETTINGS,
	route.SPACE_SETTINGS_REORDERPAGES,
	route.SPACE_OVERVIEW_REDIRECT_LEGACY,
	route.DELETE_SPACE_LEGACY,
	route.SPACE_INDEX,
	route.SPACE_OVERVIEW,
	route.AI_PLANNER_CONFLUENCE_BRIDGE,
	route.HUB,
	route.HUB_EDIT,
	route.COMPANY_HUB,
	route.COMPANY_HUB_ANALYTICS,
	route.COMPANY_HUB_EDIT,
	route.COMPANY_HUB_SETTINGS,
	route.VIEW_PAGE,
	route.NEXT_VIEW_PAGE,
	route.PAGE_SPLIT,
	route.BLOG_HOME,
	route.VIEW_BLOG,
	route.WHITEBOARD_HOME,
	route.WHITEBOARD_BOARD,
	route.SLIDES_VIEW,
	route.CONTACT_ADMINISTRATOR,
	route.ADMIN_SETTINGS,
	route.ADMIN_GLOBAL_AUTOMATION,
	route.ADMIN_EDIT_EXTERNAL_SHARING,
	route.ADMIN_ANONYMOUS_ACCESS,
	route.ADMIN_SPACE_MANAGEMENT,
	route.ADMIN_SPACE_DEFAULTS,
	route.ADMIN_SPACE_ROLES,
	route.ADMIN_SITE_PERMISSIONS,
	route.ADMIN_GUESTS,
	route.ADMIN_APP_PERMISSIONS,
	route.ADMIN_JSM_ACCESS,
	route.ADMIN_FORGE_APPS_REDIRECT,
	route.ADMIN_FORGE_APPS,
	route.ADMIN_NEW_GLOBAL_PERMISSIONS,
	route.ADMIN_COMPANY_HUB_PERMISSIONS,
	route.ADMIN_COMPANY_HOME_BUILDER,
	route.ADMIN_CUSTOMIZE_NAVIGATION,
	route.ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS,
	route.ADMIN_SITE_SPACE_PERMISSIONS,
	route.SPACE_PERMISSIONS_APPS,
	route.EDIT_SPACE_PERMISSIONS_APPS,
	route.ADMIN_CONFLUENCE_CHATS_INTEGRATION,
	route.CONFLUENCE_MSTEAMS_SIGNIN_CONFIRMATION,
	route.ADMIN_AUDIT_LOG,
	route.ADMIN_BROWSE_SHORTCUTS,
	route.ADMIN_CREATE_SHORTCUT,
	route.ADMIN_REMOVE_SHORTCUT,
	route.ADMIN_DARK_FEATURES,
	route.ADMIN_ENABLE_DARK_FEATURE,
	route.ADMIN_DISABLE_DARK_FEATURE,
	route.ADMIN_BETA_FEATURES,
	route.ADMIN_NEW_FEATURES,
	route.ADMIN_LIVE_EDIT,
	route.SPACE_CALENDAR,
	route.SPACE_CALENDARS,
	route.SPACE_CALENDARS_SUBCALENDAR,
	route.SPACE_EMBEDDED_SUBCALENDAR,
	route.MULTIPLE_SUBCALENDAR,
	route.EMBEDDED_MULTIPLE_SUBCALENDAR,
	route.DISCOVER,
	route.ALL_UPDATES,
	route.POPULAR,
	route.MY_WORK_HOME,
	route.MY_WORK_DRAFTS,
	route.MY_WORK_RECENT,
	route.MY_RECENTLY_VISITED,
	route.MY_SAVED_FOR_LATER,
	route.RECENT_PAGES,
	route.RECENT_VISITED,
	route.RECENT_DRAFTS,
	route.RECENT_SAVED,
	route.TEMPLATE_MIGRATION_PREVIEW,
	route.EDIT_TEMPLATE,
	route.EDIT_TEMPLATE_BLUEPRINT,
	route.EDIT_TEMPLATE_SPACE,
	route.CREATE_TEMPLATE,
	route.CREATE_TEMPLATE_SPACE,
	route.HELLO_WORLD,
	route.DASHBOARD_ACTION_LEGACY,
	route.SPA_ACTION_LEGACY,
	route.INDEX_ACTION_LEGACY,
	route.CREATE_PAGE_ACTION_LEGACY,
	route.CREATE_BLOG_ACTION_LEGACY,
	route.CREATE_PAGE_VARIABLES_ACTION_LEGACY,
	route.RESUME_DRAFT_LEGACY,
	route.COPY_PAGE_LEGACY,
	route.VIEW_PAGE_ACTION_LEGACY,
	route.SPACE_OVERVIEW_INDEX_ACTION_LEGACY,
	route.SPACE_INDEX_ACTION_LEGACY,
	route.SPACE_PAGES,
	route.VIEW_BLOG_DATE_LEGACY,
	route.ACTION_REDIRECT_LEGACY,
	route.ADVANCED_SEARCH_LEGACY,
	route.ADVANCED_SEARCH,
	route.EXTERNAL_SHARE,
	route.ACCESS_LINK,
	route.PDF_EXPORT_PAGE,
	route.PDF_EXPORT_SPACE,
	route.LEGACY_SPACE_PDF_EXPORT,
	route.EXPORT_SPACE_CSV,
	route.EXPORT_SPACE_XML,
	route.EXPORT_SPACE_HTML,
	route.SPACE_SETTINGS_EXPORT,
	route.SPACE_LEGACY_CONTENT,
	route.VIEW_PAGE_MOBILE,
	route.VIEW_BLOG_MOBILE,
	route.PEOPLE_DIRECTORY_SEARCH,
	route.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH,
	route.MARKETPLACE_FIND_APPS,
	route.MARKETPLACE_APP_REQUESTS,
	route.MARKETPLACE_MANAGE_PROMOTIONS,
	route.PEOPLE_DIRECTORY,
	route.SPACE_RESTRICTED_PAGES,
	route.SPACE_ARCHIVED_PAGES,
	route.SPACE_SUGGESTIONS,
	route.PAGE_DIFF_BY_VERSION,
	route.SITE_ANALYTICS,
	route.SITE_ANALYTICS_PERMISSIONS,
	route.SPACE_ANALYTICS,
	route.SPACE_ANALYTICS_PERMISSIONS,
	route.PAGE_ANALYTICS,
	route.SPACE_QUESTIONS,
	route.SPACE_QUESTIONS_NATIVE,
	route.SPACE_QUESTION_NATIVE,
	route.SPACE_CUSTOM_CONTENT_LIST,
	route.CUSTOM_CONTENT_VIEW,
	route.SPACE_BULK_TOOLS,
	route.SPACE_SETTINGS_LANDING_PAGE,
	route.SPACE_SETTINGS_LANDING_PAGE_ALT,
	route.SPACE_SETTINGS_AUTOMATION,
	route.SPACE_SETTINGS_ARCHIVE_SPACE,
	route.SPACE_SETTINGS_TRASH_SPACE,
	route.SPACE_FORGE_APPS,
	route.GLOBAL_PAGE_FORGE,
	route.SPACE_SETTINGS_FORGE_APPS,
	route.SPACE_SETTINGS_AVATARS_AND_STATUS,
	route.SPACE_SETTINGS_STATUS_AND_APPROVALS,
	route.SPACE_SETTINGS_AVATARS,
	route.SPACE_SETTINGS_CONTENT_STATE,
	route.SPACE_SETTINGS_DATA_CLASSIFICATION,
	route.SPACE_SETTINGS_WATERMARK_CONFIGURATION,
	route.SPACE_SETTINGS_EXPORT_SPACE,
	route.SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE,
	route.SPACE_SETTINGS_HIDDEN_PAGES,
	route.SPACE_SETTINGS_RELATED_PAGES,
	route.SPACE_SETTINGS_UNDEFINED_PAGES,
	route.SPACE_SETTINGS_ATTACHMENTS,
	route.SPACE_SETTINGS_APPLICATION_LINKS,
	route.SPACE_SETTINGS_RSS_FEEDS,
	route.SPACE_SETTINGS_EDITOR_CONVERSION,
	route.SPACE_LOOK_AND_FEEL_SETTINGS,
	route.SPACE_TRASH,
	route.MOBILE_TAKEOVER_PAGE,
	route.MOBILE_MACRO_RENDERER,
	route.DEFAULT_ADMIN_MANAGE_APPS,
	route.ADMIN_APP_AUDIT_LOGS,
	route.SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY,
	route.ADMIN_TEMPLATES_AND_BLUEPRINTS,
	route.ADMIN_APPLICATION_NAVIGATOR,
	route.CUSTOM_CONTENTS_ON_PAGE_LIST,
	route.SPACE_PERMISSIONS_SETTINGS,
	route.SPACE_SETTINGS_ACCESS_LINKS,
	route.SPACE_SETTINGS_ACCESS_LINKS_CONFIGURATION,
	route.ROLE_BASED_ACCESS_CONTROL_HUB,
	route.USER_ACCESS,
	route.PERMISSIONS_EXPORT,
	route.PERMISSIONS_COMBINATIONS,
	route.ADMIN_SYSTEM_OPERATIONS,
	route.ADMIN_ANNOUNCEMENT_BANNER_RENDERER,
	route.IMPORTER_STATUS_DASHBOARD,
	route.SPACE_MANAGER,
	route.ADMIN_CENTER,
	route.ADMIN_CENTER_SPACE,
	route.ADMIN_TEAM_CALENDARS,
	route.ADMIN_TEAM_CONTROLS,
	route.ADMIN_CONFIGURATION,
	route.ADMIN_DEFAULT_SPACE_LOGO,
	route.ADMIN_HEADER_AND_FOOTER,
	route.ADMIN_ACCESS_REQUESTS,
	route.ADMIN_SECURITY_CONFIGURATION,
	route.ADMIN_ACCESS_LINKS,
	route.ADMIN_ACCESS_LINKS_CONFIGURATION,
	route.ADMIN_SPACE_REPORTS,
	route.ADMIN_STORAGE_MANAGEMENT,
	route.ADMIN_CODE_MACRO_CONFIGURATION,
	route.ADMIN_COLOR_SCHEME,
	route.DATABASE_VIEW,
	route.DATABASE_CUSTOM_OVERVIEW,
	route.DATABASE_CUSTOM_VIEW,
	route.EMBED_VIEW,
	route.FOLDER_VIEW,
	route.SPACE_SETTINGS_EDIT_FEATURES,
	route.ADMIN_BULK_PERMISSIONS,
	route.ADMIN_NOTIFICATIONS,
	route.PERFORMANCE_INSIGHTS_NETWORK_SPEED,
	route.PERFORMANCE_INSIGHTS_CPU_CORES,
	route.PERFORMANCE_INSIGHTS_NETWORK_PROTOCOL,
	route.PERFORMANCE_INSIGHTS_OPERATING_SYSTEM,
	route.PERFORMANCE_INSIGHTS,
	route.ADMIN_TRASHED_SPACES,
	route.ADMIN_JIRA_MACRO_REPAIR,
	route.ADMIN_IMPORT_SPACES,
	route.ADMIN_MACRO_USAGE,
	route.ADMIN_MACRO_USAGE_LEGACY,
	route.ADMIN_NBM_MIGRATION,
	route.ADMIN_NBM_MIGRATION_SCAN,
	route.ADMIN_NBM_MIGRATION_UNSUPPORTED,
	route.ADMIN_NBM_MIGRATION_UNVERIFIED,
	route.ADMIN_NBM_MIGRATION_SCANS,
	route.ADMIN_NBM_MIGRATION_RUN_TRANSFORMATIONS,
	route.ADMIN_NBM_MIGRATION_TRANSFORMATIONS,
	route.SPACE_MEMBERS,
	route.ADMIN_THEMES,
	route.ADMIN_PDF_EXPORT,
	route.ADMIN_WATERMARK_CONFIGURATION,
	route.CREATE_TEMPLATE_SITE_LEGACY,
	route.CREATE_TEMPLATE_SPACE_LEGACY,
	route.SITE_SETTINGS_EDIT_TEMPLATE_LEGACY,
	route.SPACE_SETTINGS_TEMPLATES,
	route.SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY,
	route.TOPICS,
	route.LABELLED_CONTENT,
	route.SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY,
	route.EDIT_DEFAULT_BLUEPRINT_LEGACY,
	route.SPACE_SETTINGS_AGENT_CONTEXT,
	route.SPACE_SETTINGS_DETAILS,
	route.PREMIUM_ADMIN_FEATURES_EXPERIMENT,
	route.ATTACHMENTS_PAGE,
	route.NEW_AUDIT_LOG,
	route.CHAT,
	route.INFERRED_PROJECT_PAGE,
	route.INFERRED_PROJECT_PAGE_WITH_ARI,
].reduce(
	(acc, route) => {
		acc[route.name] = route;
		return acc;
	},
	{} as { [name: string]: Route },
);
